<template>
  <div class="honer">
    <el-table
      :data="ruleForm.form"
      style="width: 100%"
      id="outTable"
      v-show="false"
    >
      <el-table-column prop="level" label="荣誉级别" width="180">
      </el-table-column>
      <el-table-column prop="company" label="主办单位" width="180">
      </el-table-column>
      <el-table-column prop="name" label="荣誉全称"> </el-table-column>
      <el-table-column prop="qt" label="荣誉全称(备注)"> </el-table-column>
      <el-table-column prop="field" label="所属领域"> </el-table-column>
      <el-table-column prop="time" label="获取时间">
        <template slot-scope="scope">
          <div>
            {{ parseTime(scope.row.time) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div style="display: flex; align-items: flex-end; padding: 5px 0 0px 20px">
      <h2 style="margin-top: 10px;">个人所获荣誉列表</h2>
      <span style="color: rgba(16, 16, 16, 100); font-size: 14px;margin-bottom: 4px"
        >&nbsp; 请按获奖时间从远到近上传获奖信息(若无荣誉则删除此条数据)</span
      >
      <span
        v-if="
          !isRed
            ? false
            : formerList != null
            ? currentList != formerList
            : false
        "
        style="color: red"
        >已修改</span
      >
    </div>
    <div class="sub">
      <a
        href="https://politics-yun.oss-cn-hangzhou.aliyuncs.com/3ae4c8f7f96dc88813c0aa8c0a2988e1/2022-02-22/荣誉下载.doc"
        download="荣誉下载"
        style="margin-right: 10px"
        ><el-button type="primary">荣誉下载</el-button>
      </a>
      <el-button type="primary" @click="add">添加证书</el-button>
    </div>
    <el-form
      :rules="rules"
      ref="ruleForm"
      :model="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div
        style="display: flex; flex-wrap: wrap; position: relative"
        class="border"
        v-for="(item, index) in ruleForm.form"
        :key="index"
      >
        <p style="position: absolute; right: 25px;cursor: pointer" @click="del(index)">删除</p>
        <el-form-item
          label="荣誉级别"
          :prop="'form.' + index + '.level'"
          :rules="rules.level"
        >
          <!-- {{ item.level }} -->
          <el-select
            v-model="item.level"
            placeholder="请选择荣誉级别"
            style="width: 100%"
            @change="change(index)"
          >
            <el-option
              v-for="item in leaveList"
              :key="item.id"
              :label="item.honor_level"
              :value="item.honor_level"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="主办单位"
          :prop="'form.' + index + '.company'"
          :rules="rules.company"
        >
          <el-select
            v-model="item.company"
            placeholder="请选择主办单位"
            style="width: 100%"
            @change="nameChange(index, item)"
          >
            <el-option
              v-for="item in company"
              :key="item.id"
              :label="item.organizer"
              :value="item.organizer"
            ></el-option>
          </el-select>
          <!-- <i class="el-icon-s-opportunity red"></i> -->
        </el-form-item>
        <el-form-item
          label="荣誉全称"
          :prop="'form.' + index + '.name'"
          :rules="rules.name"
        >
          <el-select
            v-model="item.name"
            placeholder="请选择荣誉全称"
            style="width: 100%"
          >
            <el-option
              v-for="item in nameList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-input
            v-model="item.qt"
            placeholder="请输入"
            style="width: 100%"
            v-if="item.name == '其他先进个人'"
          >
          </el-input>
          <!-- <i class="el-icon-s-opportunity red"></i> -->
        </el-form-item>

        <el-form-item
          label="所属领域"
          :prop="'form.' + index + '.field'"
          :rules="rules.field"
        >
          <el-select
            v-model="item.field"
            placeholder="请选择所属领域"
            style="width: 100%"
          >
            <el-option label="全部" value="全部"></el-option>
          </el-select>
          <!-- <i class="el-icon-s-opportunity red"></i> -->
        </el-form-item>

        <el-form-item
          label="获取时间"
          :prop="'form.' + index + '.time'"
          :rules="rules.time"
        >
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="item.time"
            style="width: 100%"
            value-format="timestamp"
          ></el-date-picker>
          <!-- <i class="el-icon-s-opportunity red"></i> -->
        </el-form-item>
        <!-- 单图模式 -->
        <!-- <el-form-item
          label="荣誉证书"
          style="width: 100%"
          :prop="'form.' + index + '.imageUrl'"
          :rules="rules.imageUrl"
          class="w"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            accept="image/*"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onChangeImg"
          >
            <img
              v-if="item.imageUrl.length > 0"
              :src="item.imageUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="annotations">请上传JPG\JPEG格式（图片大小限制在500k-5MB）</div>
        </el-form-item> -->
        <!-- 多图模式 -->
        <el-form-item
          label="荣誉证书"
          style="width: 100%; margin-bottom: 20px"
          :prop="'form.' + index + '.imageUrl'"
          :rules="rules.imageUrl"
          class="w"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            accept="image/*"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="(file, fileList) => {onChangeImgCopy(file, fileList, index)}"
          >
            <div
              style="display: flex; position: relative; margin-left: 8px"
              @click.stop
              v-for="(items, idx) in item.imageUrl"
              :key="idx"
            >
              <img :src="items" class="avatar" />
              <div class="file">
                <i
                  class="el-icon-zoom-in"
                  @click="handlePictureCardPreview(items)"
                ></i>
                <!-- <span
                  class="el-upload-list__item-delete"
                  @click="handleDownload(file)"
                > -->
                <i class="el-icon-download" @click="handleDownload(items)"></i>
                <!-- </span> -->
                <i class="el-icon-delete" @click="handleRemove(index,idx)"></i>
              </div>
            </div>
            <i
              v-if="item.imageUrl.length < 1"
              class="el-icon-plus avatar-uploader-icon"
              style="margin-left: 8px"
            ></i>
          </el-upload>
          <div
            class="annotations"
            style="white-space: nowrap; line-height: 1.5;margin-top: 10px;"
          >
            请上传jpg/png格式的扫描件图片
          </div>
        </el-form-item>
      </div>
      <div class="btnDiv">
        <el-button
          type="primary"
          ref="rongyu"
          @click="upper('ruleForm')"
          class="btn"
          >上一页</el-button
        >
        <el-button
          type="primary"
          ref="rongyu"
          @click="submitForm('ruleForm')"
          class="btn"
          >下一页</el-button
        >
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { gethonorList } from "@/api/open";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { parseTime } from "@/filters/index";
export default {
  props: ["secondList"],
  data() {
    return {
      list: 1,
      imageUrl: false,
      imgUrlId: 0,
      currentList: [], //倒数第一次数据
      formerList: null, //倒数第二次数据
      ruleForm: {
        form: [
          {
            level: "", //级别
            company: "", //单位
            name: "", //全称
            field: "", //领域
            qt: "",
            time: "", //时间
            imageUrl: [], //证书
          },
        ],
      },
      rules: {
        level: [{ required: true, message: "请选择", trigger: "blur" }],
        company: [{ required: true, message: "请选择", trigger: "blur" }],
        name: [{ required: true, message: "请选择", trigger: "blur" }],
        field: [{ required: true, message: "请选择", trigger: "change" }],
        time: [{ required: true, message: "请选择", trigger: "change" }],
        imageUrl: [{ required: true, message: "请选择", trigger: "change" }],
      },
      company: [], //主办单位数据
      nameList: [], //荣誉全称数据（由于页面改动较多，名称意思和数据可能对不上，没有任何问题，具体参照备注）
      leaveList: [], //荣誉级别数据
      isRed: false, //是否显示标红
      dialogImageUrl: "", //查看图片弹窗使用
      dialogVisible: false, //查看图片弹窗使用
    };
  },
  mounted() {
    this.dataList();
    if (this.$route.path != "/taggingManage/personal-center") {
      this.isRed = true;
    }
  },
  methods: {
    downloadval() {
      let vb = XLSX.utils.table_to_book(document.getElementById("outTable"));

      let vbout = XLSX.write(vb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });

      try {
        FileSaver.saveAs(
          new Blob([vbout], { type: "application/octet-stream" }),
          "荣誉下载.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, vbout);
      }
      return vbout;
    },

    add() {
      this.nameList = [];
      this.ruleForm.form.push({
        level: "", //级别
        company: "", //单位
        name: "", //全称
        field: "", //领域
        time: "", //时间
        qt: "",
        imageUrl: [], //证书
      });
    },
    submitForm(formName) {
      // console.log(formName);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.$emit("honor", this.ruleForm.form);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    subClick() {
      this.$refs.rongyu.$el.click();
    },
    //上一页
    upper() {
      this.$emit("honor", "top");
    },
    // 平台logo上传(单图模式)
    onChangeImg(file) {
      this.uploadImgToOss(file)
        .then((res) => {
          if (res.status == 200) {
            console.log(res.data.data);
            this.ruleForm.form[this.imgUrlId].imageUrl =
              this.ossUrl + res.data.data;
          }
        })
        .catch((error) => {});
    },
    ///////////多图模式
    onChangeImgCopy(file,fileList,itemIdx) {


      if (this.ruleForm.form[itemIdx].imageUrl.length >= 1) {
        this.$message.error("最多上传1张");
        return;
      }
      this.uploadImgToOss(file)
        .then((res) => {
          if (res.status == 200) {
            this.ruleForm.form[itemIdx].imageUrl.push(
              this.ossUrl + res.data.data
            );
          }
        })
        .catch((error) => {});
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    handleRemove(itemIdx,imgIdx) {

      this.ruleForm.form[itemIdx].imageUrl.splice(imgIdx, 1);
    },


    handleDownload(file) {
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = file;
      a.target = "_blank";
      a.click();
    },
    //删除
    del(index) {
      console.log(index);
      this.ruleForm.form.splice(index, 1);
    },
    //下拉框的数据
    dataList(val, num, organizer) {
      let parmas = {
        organizer: organizer,
        level: val,
      };
      gethonorList(parmas).then((res) => {
        console.log(res);
        if (res.code == 200) {
          if ((num == 1) & !organizer) {
            this.company = res.data;
          } else if (organizer) {
            this.nameList = res.data;
          } else {
            // this.company = res.data;
            this.leaveList = [
              { honor_level: "国家级" },
              { honor_level: "省（部）级" },
              { honor_level: "厅局（市）级" },
              { honor_level: "县（区）级" },
            ];
          }
        }
      });
    },
    change(index) {
      console.log(this.ruleForm.form[index].level);
      this.ruleForm.form[index].name = "";
      this.ruleForm.form[index].company = "";
      this.dataList(this.ruleForm.form[index].level, 1);
    },
    nameChange(index, val) {
      console.log(this.leaveList, val);
      // let t;
      // for (let index = 0; index < this.leaveList.length; index++) {
      //   if (this.leaveList[index].name == val) {
      //     console.log(index);
      //     t = index;
      //   }
      // }
      // console.log(t);
      this.ruleForm.form[index].name = "";
      this.dataList(this.ruleForm.form[index].level, 1, val.company);
    },
    getCurrentList(val) {
      if (val != null) {
        this.currentList = val;
        this.ruleForm.form = JSON.parse(val).sort(function (a, b) {
          console.log(a);
          return b.time - a.time;
        });
        console.log(this.ruleForm.form);
      }
    },
    getFormerListList(val) {
      if (val != null) {
        this.formerList = val;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/index.scss";
.honer {
  height: 100%;
  width: 100%;

  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid #e4e7ed;
  //   padding: 20px 20px;
  display: flex;
  flex-direction: column;
  .demo-ruleForm {
    padding: 0 0 0 10px;
    flex: 1;
    overflow-y: scroll;
  }
}
/deep/.el-input__inner {
  height: 36px;
}
.sub {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-right: 12px;
  /deep/.el-button {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0.7rem 0.8rem;
    border: none;
  }
}
.el-form-item {
  width: 30%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 83px;
  height: 83px;
  line-height: 83px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 83px;
  height: 83px;
  display: block;
}
.annotations {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
/deep/.el-form-item {
  margin-bottom: 15px;
}

.border {
  border: 1px solid #e4e7ed;
  padding-top: 10px;
  margin-bottom: 5px;
}

.w {
  /deep/.el-form-item__content {
    display: inline-block;
    margin-left: 0 !important;
  }
}

.file {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: #000;
  opacity: 0;
  // border-radius: 50%;
  i {
    color: #fff;
    margin-right: 5px;
    margin-left: 5px;
  }
}

.file:hover {
  opacity: 0.5;
}
/deep/.el-upload {
  display: flex;
}
/deep/.el-dialog__header {
  border-bottom: none;
}
/deep/.el-dialog {
  margin-top: 50vh !important;
  transform: translate(0vh, -50%);
}
</style>